import { render, staticRenderFns } from "./PosterDialog.vue?vue&type=template&id=26a4ad60&scoped=true"
import script from "./PosterDialog.vue?vue&type=script&lang=ts"
export * from "./PosterDialog.vue?vue&type=script&lang=ts"
import style0 from "./PosterDialog.vue?vue&type=style&index=0&id=26a4ad60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4ad60",
  null
  
)

export default component.exports